var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "toggle-atc" }, [
    _vm.justAddedToCart || _vm.productAlreadyInCart
      ? _c(
          "button",
          {
            staticClass:
              "pdp__atc product-form__atc button button--secondary toggle-atc__added",
            attrs: { disabled: "" }
          },
          [_c("icon", { attrs: { name: "check-black", size: "24" } })],
          1
        )
      : !_vm.product.available
      ? _c("a", { attrs: { href: _vm.product.url } }, [
          _c(
            "button",
            {
              staticClass:
                "pdp__atc product-form__atc button button--secondary toggle-atc__not-added"
            },
            [_vm._v("OUT OF STOCK")]
          )
        ])
      : _c(
          "button",
          {
            staticClass:
              "pdp__atc product-form__atc button button--secondary toggle-atc__not-added",
            attrs: { type: "submit", name: "add", "data-add-to-cart": "" },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.addToCart(
                  _vm.product.selectedOrFirstAvailableVariant
                )
              }
            }
          },
          [_vm._v("ADD TO BAG")]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }